<template>
  <div>
    <div class="row-container-presentation">
      <div class="col-description-caravan">
        <span class="greetings-p"
          >Olá,
          <b style="color: #000">{{
            participant && participant?.name ? participant?.name + "!" : " "
          }}</b></span
        >
        <p style="width: 100%">Sua inscrição está associada com</p>
        <b style="color: blue">{{ caravanistNamePresenter }}</b>
      </div>
    </div>
    <vs-row
      ><h2 class="edit-title">Confira se seus dados estão atualizados👇</h2>
    </vs-row>
    <div class="container-part-data">
      <div class="sub-part-photo-container">
        <div
          class="send-photo-chip"
          v-if="!(participant && participant?.photo)"
        >
          <i class="fa fa-triangle-exclamation" style="margin-right: 4px"></i
          >Você precisa enviar sua foto!
        </div>

        <vs-row vs-justify="center">
          <div
            id="div-with-loading"
            class="avatar-container vs-con-loading__container"
          >
            <img class="avatar-img" :src="photoPreview" />
          </div>
        </vs-row>
        <vs-row vs-justify="center">
          <div>
            <label for="arquivo1">
              <span v-if="!isNewUser && isUploadingAvatar">
                <i
                  class="fas fa-circle-notch fa-spin"
                  style="color: #fff; font-size: 15px; margin-right: 10px"
                ></i>
                Aguarde...
              </span>
              <vs-row v-else style="align-items: center" vs-justify="center">
                <feather-icon
                  style="margin-right: 10px"
                  icon="CameraIcon"
                  class="cursor-pointer"
                >
                </feather-icon>
                Tirar Foto
              </vs-row>
            </label>
            <input
              type="file"
              ref="file1"
              name="file1"
              id="arquivo1"
              capture="camera"
              accept="image/*"
              @change="readFile(1)"
            />
          </div>
        </vs-row>
      </div>

      <h5 style="margin-top: 16px">Dados pessoais:</h5>
      <div v-if="participant && participant?.name">
        <hr />
        <div class="table-row-part">
          <div class="col-label-part">Nome:</div>
          <div>{{ participant?.name }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Sobrenome:</div>
          <div>{{ participant?.surname }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Gênero:</div>
          <div>{{ participant?.gender | formatGender }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Nome social:</div>
          <div>{{ participant?.selfRefer || "" }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Nascimento:</div>
          <div>{{ participant?.birthdate | formatDate }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Nacionalidade:</div>
          <div>{{ participant?.nationality || "" }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Estado civil:</div>
          <div>{{ participant?.maritalStatus || "" }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Cpf:</div>
          <div>{{ participant?.cpf }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Rg:</div>
          <div>{{ participant?.rg }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">Telefone:</div>
          <div>{{ participant?.mobile }}</div>
        </div>
        <div class="table-row-part">
          <div class="col-label-part">E-mail:</div>
          <div>{{ participant?.email }}</div>
        </div>

        <div v-if="participant?.address">
          <h5 style="margin-top: 24px">Endereço:</h5>
          <hr />
          <div class="table-row-part">
            <div class="col-label-part">Cep:</div>
            <div>{{ participant?.address?.zipCode }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Estado:</div>
            <div>{{ participant?.address?.state }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Município:</div>
            <div>{{ participant.address?.city }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Bairro:</div>
            <div>{{ participant.address?.neighborhood }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Rua:</div>
            <div>{{ participant.address?.street }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Número:</div>
            <div>{{ participant.address?.number }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Complemento:</div>
            <div>{{ participant.address?.complement }}</div>
          </div>

          <h5 style="margin-top: 24px">Aceites:</h5>
          <hr />
          <div class="table-row-part">
            <div class="col-label-part">Termos:</div>
            <div>{{ participant?.terms ? "Aceito" : "Não aceito" }}</div>
          </div>
          <div class="table-row-part">
            <div class="col-label-part">Cessão de imagem:</div>
            <div>
              {{ participant?.imageAssignment ? "Aceito" : "Não aceito" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCaravanistFromLocalStorage,
  getTokenFromLocalStorage,
  getParticipantFromLocalStorage,
  storageParticipant,
} from "../../../utils/jwt";
import { resizeImage } from "../../../utils/image";
import moduleParticipant from "@/store/participant/moduleParticipant";
import { sendSentryMessage } from "../../../utils/sentry";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    alerta: {},
    source: {
      type: String,
      required: false,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    caravanist() {
      if (
        this.participant &&
        this.participant.caravanistParticipant &&
        this.participant.caravanistParticipant.length > 0
      ) {
        return this.participant.caravanistParticipant[0].caravanist;
      }
      return getCaravanistFromLocalStorage();
    },
    caravanistNamePresenter() {
      const params = new URLSearchParams(window.location.search);
      let name = "";
      if (params && params.get("name")) {
        name = params.get("name");
      } else {
        const href = window.location.href;
        const hrefParts = href.split("?name=");
        if (hrefParts && hrefParts.length > 1) {
          const nameUrl = hrefParts[1];
          name = decodeURI(nameUrl);
        }
      }
      if (name) {
        return name;
      } else if (this.caravanist && this.caravanist?.name) {
        return this.caravanist?.name;
      } else {
        return " - ";
      }
    },
    participant() {
      return this.data.participantData
        ? JSON.parse(JSON.stringify(this.data?.participantData))
        : null;
    },
    photoPreview() {
      if (
        this.participantData &&
        participantData?.participant &&
        participantData?.participant?.photo
      ) {
        return this.participantData.participant.photo;
      } else if (
        this.data?.participantData &&
        this.data?.participantData?.photo
      ) {
        return this.data.participantData.photo;
      } else {
        return this.preview;
      }
    },
  },
  data() {
    return {
      photo: null,
      isNewUser: false,
      isUploadingAvatar: false,
      preview: require("../../../assets/images/portrait/avatar.png"),
    };
  },
  filters: {
    formatDate: formatDateBr,
    formatGender: formatGender,
  },
  methods: {
    goToPhoto() {
      this.$emit("goToPhoto");
    },
    readFile(index) {
      let ref = null;
      switch (index) {
        case 0:
          ref = this.$refs.file0.files[0];
          break;
        case 1:
          ref = this.$refs.file1.files[0];
          break;
        case 2:
          ref = this.$refs.file2.files[0];
          break;
      }
      this.selectedInput = ref;

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          resizeImage(reader.result, 600, null, "huge-photo.jpg")
            .then((res) => {
              this.preview = res;
              this.photo = res;
              // this.form.photo = res;
              // this.isActiveStep4Button = true;

              this.updateAvatar();
            })
            .catch((e) => {
              sendSentryMessage(
                "FOTO - Falha ao redimensionar (atualizacao)  ❌",
                "error",
                "photo",
                {
                  error: e,
                }
              );
            });
        }
      };
      reader.onerror = (e) => {
        sendSentryMessage(
          "FOTO - Falha ao carregar (atualizacao)  ❌",
          "error",
          "photo",
          {
            error: e,
          }
        );
      };

      reader.readAsDataURL(this.selectedInput);
    },
    async updateAvatar() {
      const token = await getTokenFromLocalStorage(this.participant?.cpf);
      console.log("used token for photo --->>>", token);
      this.isUploadingAvatar = true;
      this.$store
        .dispatch("participant/updatePhoto", {
          photo: this.photo,
          token,
        })
        .then((resp) => {
          const res = resp;
          const newPhoto = res.data.url;
          let cpf = null;
          if (this.participantData && participantData.participant) {
            this.participantData.participant.photo = newPhoto;
            cpf = this.participantData.participant.cpf;
          }
          if (this.data.participantData && this.data.participantData.photo) {
            this.data.participantData.photo = newPhoto;
            cpf = this.data.participantData.cpf;
          }

          const previousParticipant = getParticipantFromLocalStorage(cpf);
          console.log({ previousParticipant, cpf, newPhoto });

          if (previousParticipant) {
            previousParticipant.photo = newPhoto;
            storageParticipant(previousParticipant, cpf);
          }
          sendSentryMessage("FOTO 📷 - Atualizada!! ✅️", "info", "photo");
        })
        .catch((e) => {
          sendSentryMessage(
            " 📸 Falha ao atualizar a foto do Participante ❌❌❌",
            "error",
            "photo",
            {
              error: e,
            }
          );
        })
        .finally(() => {
          this.isUploadingAvatar = false;
        });
    },
  },
  created() {
    if (!moduleParticipant.isRegistered) {
      this.$store.registerModule("participant", moduleParticipant);
      moduleParticipant.isRegistered = true;
    }
  },
};
import {
  formatGender,
  formatDateBr,
} from "../../../utils/subscriptionFunctions";
</script>

<style lang="scss" scoped>
.greetings-p {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.avatar-container {
  width: 250px;
  height: 250px;
  margin: 20px auto 0 auto;
}
.avatar-img {
  width: 250px;
  height: 250px;
  background: #eee;
  object-fit: cover;
  border-radius: 4px;
}

.col-description-caravan {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  justify-content: center;
}
.edit-title {
  margin-top: 10px;
  font-size: 14px;
  width: 100%;
  text-align: center;
}
.send-photo-chip {
  background: orange;
  color: #000;
  font-size: 13px;
  font-weight: bold;
  border-radius: 16px;
  padding: 4px 12px;
  margin-top: 6px;
}
.sub-part-photo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 10px 0;

  input[type="file"] {
    display: none;
  }
  label {
    position: absolute;
    padding: 10px;
    width: 220px;
    border-radius: 4px;
    background-color: rgba($color: #fff, $alpha: 0.75);
    margin-top: -56px;
    margin-left: -110px;
    color: #000;
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.row-container-presentation {
  display: flex;
  flex-direction: row;
  margin: 16px 0;
}
.col-photo-caravan {
  width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.col-photo-caravan img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
  background-color: #ccc;
}

.container-part-data {
  display: flex;
  flex-direction: column;
  font-size: 13px;
}
.container-part-data h5 {
  font-weight: bold;
  color: #000;
  font-size: 16px;
  margin-top: 10px;
}
.container-part-data hr {
  border: 1px solid #eee;
  margin: 4px 0 10px 0;
}
.table-row-part {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.col-label-part {
  display: flex;
  width: 120px;
  font-weight: bold;
}
.col-content {
  display: flex;
}
</style>
